import React from "react";

const ProgressBar = ({ level, exp, maxExp }) => {
    const progressWidth = (exp / maxExp) * 100;
  
    return (
      <div className="rounded-full w-full">
        <div className="flex justify-between text-sm font-semibold">
          <span className="text-sm font-medium text-gray-700">User Level: {level}</span>
          <span className="text-sm font-medium text-gray-700">EXP: {exp}/{maxExp}</span>
        </div>
        <div className="w-full bg-gray-200 rounded-full h-2 mt-1">
          <div
            className="bg-[#FF4433] h-2 rounded-full transition-all"
            style={{ width: `${progressWidth}%` }}
          ></div>
        </div>
      </div>
    );
  };

  export default ProgressBar;
  